export interface NamedCountItem {
  name: string;
  product_count?: number | null;
}

export function filterBySearchName<T extends NamedCountItem>(items: T[], search: string): T[] {
  if (!search.trim()) return items;
  const q = search.trim().toLowerCase();
  return items.filter((item) => item.name.toLowerCase().includes(q));
}

export function filterByWithWithoutProducts<T extends NamedCountItem>(
  items: T[],
  products: string[]
): T[] {
  if (products.length === 0) return items;
  return items.filter((item) => {
    const count = item.product_count ?? 0;
    const withProducts = count > 0;
    if (products.includes('with_products') && products.includes('without_products')) return true;
    if (products.includes('with_products')) return withProducts;
    if (products.includes('without_products')) return !withProducts;
    return true;
  });
}

export function sortByNameOrProducts<T extends NamedCountItem>(
  items: T[],
  sortOption: string
): T[] {
  const list = [...items];
  const [key, dir] = sortOption.includes('_') ? sortOption.split('_') : [sortOption, 'asc'];
  if (key === 'name') {
    list.sort((a, b) => {
      const c = a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
      return dir === 'desc' ? -c : c;
    });
  } else if (key === 'products') {
    list.sort((a, b) => {
      const countA = a.product_count ?? 0;
      const countB = b.product_count ?? 0;
      return dir === 'desc' ? countB - countA : countA - countB;
    });
  }
  return list;
}
